// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorAuctions = (client) => ({
    /**
     * `POST /vendor/auctions/:id/cancel`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorAuctionsIdCancel
     * @source packages/medusa-plugin-auction-v2/src/api/vendor/auctions/[id]/cancel/route.ts
     */
    cancel: (id, body, query, headers) => client.fetch(buildPath("/vendor/auctions/:id/cancel", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/auctions`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorAuctionsCreate
     * @source packages/medusa-plugin-auction-v2/src/api/vendor/auctions/route.ts
     */
    create: (body, query, headers) => client.fetch("/vendor/auctions", { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/auctions/:id/bids`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorAuctionsIdBidsCreate
     * @source packages/medusa-plugin-auction-v2/src/api/vendor/auctions/[id]/bids/route.ts
     */
    createBid: (id, body, query, headers) => client.fetch(buildPath("/vendor/auctions/:id/bids", [id]), { method: "POST", body, query, headers }),
    /**
     * `DELETE /vendor/auctions/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorAuctionsIdDelete
     * @source packages/medusa-plugin-auction-v2/src/api/vendor/auctions/[id]/route.ts
     */
    delete: (id, body, query, headers) => client.fetch(buildPath("/vendor/auctions/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `DELETE /vendor/auctions/:id/bids/:bidId`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorAuctionsIdBidsBidIdDelete
     * @source packages/medusa-plugin-auction-v2/src/api/vendor/auctions/[id]/bids/[bidId]/route.ts
     */
    deleteBid: (id, bidId, body, query, headers) => client.fetch(buildPath("/vendor/auctions/:id/bids/:bidId", [id, bidId]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /vendor/auctions`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @source packages/medusa-plugin-auction-v2/src/api/vendor/auctions/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/auctions", { method: "GET", query, headers }),
    /**
     * `GET /vendor/auctions/:id/bids`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorAuctionsIdBidsList
     * @source packages/medusa-plugin-auction-v2/src/api/vendor/auctions/[id]/bids/route.ts
     */
    listBids: (id, query, headers) => client.fetch(buildPath("/vendor/auctions/:id/bids", [id]), { method: "GET", query, headers }),
    /**
     * `GET /vendor/auctions/:id/earnest-participations`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorAuctionsIdEarnestParticipationsRetrieve
     * @source packages/medusa-plugin-auction-v2/src/api/vendor/auctions/[id]/earnest-participations/route.ts
     */
    listEarnestParticipations: (id, query, headers) => client.fetch(buildPath("/vendor/auctions/:id/earnest-participations", [id]), { method: "GET", query, headers }),
    /**
     * `GET /vendor/auctions/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorAuctionsIdRetrieve
     * @source packages/medusa-plugin-auction-v2/src/api/vendor/auctions/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/vendor/auctions/:id", [id]), { method: "GET", query, headers }),
    /**
     * `GET /vendor/auctions/activity`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorAuctionsActivityList
     * @source packages/medusa-plugin-auction-v2/src/api/vendor/auctions/activity/route.ts
     */
    retrieveActivity: (query, headers) => client.fetch("/vendor/auctions/activity", { method: "GET", query, headers }),
    /**
     * `GET /vendor/auctions/:id/bids/:bidId`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorAuctionsIdBidsBidIdRetrieve
     * @source packages/medusa-plugin-auction-v2/src/api/vendor/auctions/[id]/bids/[bidId]/route.ts
     */
    retrieveBid: (id, bidId, query, headers) => client.fetch(buildPath("/vendor/auctions/:id/bids/:bidId", [id, bidId]), { method: "GET", query, headers }),
    /**
     * `POST /vendor/auctions/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorAuctionsIdUpdate
     * @source packages/medusa-plugin-auction-v2/src/api/vendor/auctions/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/vendor/auctions/:id", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/auctions/:id/bids/:bidId/earnest-money`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorAuctionsIdBidsBidIdEarnestMoneyUpdate
     * @source packages/medusa-plugin-auction-v2/src/api/vendor/auctions/[id]/bids/[bidId]/earnest-money/route.ts
     */
    updateBidsEarnestMoney: (id, bidId, body, query, headers) => client.fetch(buildPath("/vendor/auctions/:id/bids/:bidId/earnest-money", [id, bidId]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/auctions/:id/earnest-participation`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorAuctionsIdEarnestParticipationCreate
     * @source packages/medusa-plugin-auction-v2/src/api/vendor/auctions/[id]/earnest-participation/route.ts
     */
    updateEarnestParticipation: (id, body, query, headers) => client.fetch(buildPath("/vendor/auctions/:id/earnest-participation", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=auctions.js.map